import axios from "axios";
import { apiAxiomLog } from "./logging";

export const apiCheckMuxLiveStatus = async (id) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_MICRO_ONE_URL}/api/mux/status/${id}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          // RETURNS fileId
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    apiAxiomLog({
      stack: "frontEnd",
      function: "lib/api/video apiCheckMuxLiveStatus",
      params: client,
      error: error.toString(),
    });
    return null;
  }
};
